import { differenceInDays, differenceInWeeks, format, fromUnixTime } from "date-fns"
import { observer } from "mobx-react-lite"

import type { Token } from "@/domains/core"
import type { ILock } from "@/domains/lock"
import { BodyCaption } from "@/domains/design/components/body-caption"
import { BodyXs } from "@/domains/design/components/body-xs"
import { formatCurrency } from "@/domains/library"

interface VenammVeDetailsProps {
  lock: ILock
  governanceToken: Token
  vestedToken: Token
}

export const VenammVeDetails = observer(({ lock, governanceToken, vestedToken }: VenammVeDetailsProps) => {
  const now = new Date()
  const expiryDate = fromUnixTime(lock.lockEnds)
  const expiryDays = differenceInDays(expiryDate, now)
  const expiryWeeks = lock.hasExpired ? 0 : Math.max(0, differenceInWeeks(expiryDate, now))

  return (
    <div className="grid grid-cols-2 gap-x-3 gap-y-2 text-sm md:grid-cols-4">
      <div>
        <BodyCaption As="div" className="text-t300">
          Balance:
        </BodyCaption>
        <BodyXs As="div" className="text-t200">
          {formatCurrency(lock.lockAmount, 4)}
          {/* <span className="text-t300">{governanceToken.symbol}</span> */}
        </BodyXs>
      </div>
      <div>
        <BodyCaption As="div" className="text-t300">
          Votes:
        </BodyCaption>
        <BodyXs As="div" className="text-t200">
          {formatCurrency(lock.lockValue, 4)}
          {/* <span className="text-t300">{vestedToken.symbol}</span> */}
        </BodyXs>
      </div>
      <div>
        <BodyCaption As="div" className="text-t300">
          Has voted?
        </BodyCaption>
        <BodyXs As="div" className="text-t200">
          {lock.hasVotedThisEpoch ? "Yes" : "No"}
        </BodyXs>
      </div>
      <div>
        <BodyCaption As="div" className="text-t300">
          Has expired?
        </BodyCaption>
        <BodyXs As="div" className="text-t200">
          {lock.hasExpired ? "Yes" : "No"}
        </BodyXs>
      </div>
      <div>
        <BodyCaption As="div" className="text-t300">
          Expires in:
        </BodyCaption>
        <BodyXs As="div" className="text-t200">
          {expiryWeeks} {expiryWeeks === 1 ? "Week" : "Weeks"}
        </BodyXs>
      </div>
      <div>
        <BodyCaption As="div" className="text-t300">
          Max locked?
        </BodyCaption>
        <BodyXs As="div" className="text-t200">
          {lock.isMaxLocked ? "Yes" : "No"}
        </BodyXs>
      </div>
      <div>
        <BodyCaption As="div" className="text-t300">
          Expiry Date:
        </BodyCaption>
        <BodyXs As="div" className="text-t200">
          {format(expiryDate, "do MMM, yyyy")}
        </BodyXs>
      </div>
      <div>
        <BodyCaption As="div" className="text-t300">
          Attachments:
        </BodyCaption>
        <BodyXs As="div" className="text-t200">
          0
        </BodyXs>
      </div>
    </div>
  )
})
